<template>
  <section class="mt-28 bg-(--main-color-200)">
    <div class="max-w-6xl mx-auto pt-16 pb-16">
      <h2 class="mx-auto text-5xl font-bold text-center dark:text-black">
        Les avis de nos clients
      </h2>
      <p
        class="text-center w-full lg:w-1/2 mx-auto mt-5 text-gray-600 text-sm"
      >
        Un petit creux la nuit ? Nous sommes disponibles jusqu'à 4h du matin.
        Faites-vous plaisir avec nos délices nocturnes, livrés directement à
        votre porte en un clin d'œil!
      </p>
      <div class="quote mt-7">
        <img
          class="mx-auto"
          src="/images/reviews-quote.webp"
          alt="Icône guillemet pour les avis clients"
          width="64"
          height="59"
          style="width: 64px; height: auto;"
          loading="lazy"
          decoding="async"
        />
      </div>
      <div class="reviews mt-16">
        <UCarousel
          :items="reviews"
          :ui="{
            item: 'flex basis-full',
            container: 'rounded-lg',
            arrows: { wrapper: 'justify-center mt-3' },
            prev: 'dark:disabled:bg-white bg-(--main-color-400) dark:bg-(--main-color-600) cursor-pointer ring-none hover:bg-(--main-color-300)',
            next: 'dark:disabled:bg-white bg-(--main-color-400) dark:bg-(--main-color-600) cursor-pointer ring-none hover:bg-(--main-color-300)',
          }"
          :prev="{ color: 'white' }"
          :next="{ color: 'white' }"
          arrows
          class="w-3/5 mx-auto text-gray-600 italic"
        >
          <template #default="{ item }">
            <div class="flex flex-col justify-between h-full min-h-[200px] p-4">
              <div class="flex-1">
                <p class="text-lg">"{{ item.commentary }}"</p>
              </div>
              <div class="mt-4 text-center">
                <p class="font-bold text-lg">{{ item.name }}</p>
              </div>
            </div>
          </template>
        </UCarousel>
      </div>
    </div>
  </section>
</template>

<script setup>
const reviews = [
  {
    id: 1,
    name: "avis 1",
    grade: 4.6,
    commentary:
      "Magna dolore irure cillum tempor enim id proident elit duis adipisicing cupidatat proident deserunt. Minim nulla Lorem eiusmod id voluptate. Nisi laborum anim do ipsum aliqua culpa qui elit dolor officia ex. Id do id velit duis dolore occaecat veniam aliqua dolor proident culpa non. Dolor minim culpa voluptate proident. Est et magna enim nostrud consequat nisi exercitation eu cillum sint ex tempor ut.",
  },
  {
    id: 2,
    name: "avis 2",
    grade: 4.1,
    commentary:
      "Nostrud ipsum qui voluptate aliquip laborum excepteur eu ullamco sit est sit anim. Occaecat anim ad exercitation fugiat sint dolor exercitation magna enim duis deserunt ullamco cillum proident. Excepteur nisi nisi nostrud et sint aliqua commodo esse ipsum voluptate duis cupidatat dolore.",
  },
  {
    id: 3,
    name: "avis 3",
    grade: 3.5,
    commentary:
      "Quis dolor aliquip ex ipsum sit incididunt ut nulla commodo consequat sint.",
  },
  {
    id: 4,
    name: "avis 4",
    grade: 4.5,
    commentary:
      "Anim proident anim ipsum excepteur nisi pariatur excepteur magna in et cupidatat dolore.",
  },
  {
    id: 5,
    name: "avis 5",
    grade: 2,
    commentary: `Officia labore exercitation culpa deserunt cillum proident aute sit aute adipisicing duis laboris. Deserunt ullamco sint anim laboris commodo ex. 
            Ullamco laboris officia cillum ea ex. Nisi sint nisi id veniam ipsum veniam non. Id excepteur ut in incididunt. Occaecat cillum anim qui exercitation proident est quis tempor ipsum enim minim Lorem fugiat enim. Sit id consectetur officia culpa sit labore labore reprehenderit pariatur nostrud sunt.`,
  },
];
</script>
